export const errorLoggingPatterns = {
  downstream: {
    timeouts: {
      enable: true,
      replacePatterns: [
        'timeout',
        'SocketException',
        'Could Not Process Your Request',
        'service is temporarily unavailable',
        'SERVICE_UNAVAILABLE',
        'service unavailable',
        'BAD_GATEWAY',
        'TimeoutException',
        'Unreachable',
        'call failed',
        'GATEWAY_TIMEOUT',
        'ReadTimeout',
        'unreachable',
        'Down stream error',
        'No Zone Found',
        'Unavailable',
      ],
    },
    exceptions: {
      enable: true,
      replacePatterns: [
        'SYSTEM_ERROR',
        'APPLICATION_ERROR',
        'INFRA_ERROR',
        'exception',
        'INTERNAL_SERVER',
        'Internal server',
        'XML is Invalid',
        'out of bounds',
        'system error',
        'Customer not found',
        'Xml is invalid',
        'temporarily unavailable',
        'html',
        'empty response',
        'can not allow',
        'XML',
        'SQL',
        'CALL FAILED',
        'missing or invalid',
        'Is incomplete',
        'empty/null response',
        'Application error',
        'Document not retrieved',
        'out of bounds',
        'EOF',
        'Customer mobile number not found',
        'SHOP_CART_VERSION',
        'system error',
        'unable to process',
      ],
    },
  },
};
